import api from "../api/api";
import { practiceFeatures } from "../config/practice";

/*
 * The day list behind the sign-in sheet (and Assign Room's "who is in which
 * room" list on the dashboard), body { stdate, eddate }.
 *
 * 9928: POST v1 checkin/future/get, exactly as before.
 * 7825 (practiceFeatures().signinSheet): POST v1 /signin/get, OSA's route --
 * the same rows minus Cancelled ones. It exists on v1 only, so the request is
 * pinned to v1 (`_gw`, see api/api.js): a v2 routing rule can never send it to
 * v2, which has no such endpoint.
 */
export const postSigninSheet = (practiseid, body) =>
  practiceFeatures().signinSheet
    ? api.post(`/v1/${practiseid}/signin/get`, body, { _gw: "v1" })
    : api.post(`/v1/${practiseid}/checkin/future/get`, body);
